import Model from "./base/model";

class SimulationTableProlongation extends Model {
  resourceName() {
    return "simulation_table_prolongation";
  }

  fields() {
    return {
      simulation_table_id: "",
      user_id: "",
      date: "",
      active: "",

      simulation_table: {jsonApi: "hasOne", type: "simulation_tables"},
      user: {jsonApi: "hasOne", type: "users"},

    };
  }
}

export default new SimulationTableProlongation();
